import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolDiscordConnectPanelComponent } from '../patrol-discord-connect-panel/patrol-discord-connect-panel.component';
import {
  PatrolDiscordBotHealth,
  PatrolDiscordGuild,
} from '../../../models/patrol-discord-cockpit.model';
import { PatrolDiscordCockpitService } from '../../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord-overview',
  standalone: true,
  imports: [CommonModule, TranslatePipe, PatrolDiscordConnectPanelComponent],
  templateUrl: './patrol-discord-overview.component.html',
  styleUrl: './patrol-discord-overview.component.scss',
})
export class PatrolDiscordOverviewComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  guild = input.required<PatrolDiscordGuild>();
  botHealth = input.required<PatrolDiscordBotHealth>();
  readonly setupChecklist = this.#cockpit.setupChecklist;

  formatDate(iso: string | null | undefined): string {
    return this.#cockpit.formatDate(iso);
  }
}
